const alertRange = 1000 * 60 * 60 * 24 * 4; // 1000 ms * 60 s * 60 min * 24 hrs * 4 days
export const createMachineData = (user, group, machine) => {
  let BaseData = {
    user: "",
    group: 0,
    bandwidth: 0,
    connected: false,
    croppedVersion: "",
    lastBkp: 0,
    lastChanges: 0,
    lastConnected: 0,
    mid: "",
    name: "",
    space_active: 0,
    status: 0,
    version: "",
    lastConnectedAdjusted: 0,
  };
  BaseData = {
    ...machine,
    user,
    group,
    connected: !!machine.bandwidth,
    croppedVersion: machine.version ? machine.version.split("#")[0] : "",
  };

  const now = Date.now();
  const parsedLastBkp = Date.parse(machine.last_backup);
  const parsedLastChanges = Date.parse(machine.last_changes);
  const parsedLastConnect = Date.parse(machine.last_connected);

  let status = 1; // backup OK
  if (!machine.mid) {
    status = 0; // no devices
  } else if (parsedLastBkp === -62135596800000) {
    status = 5; // never bkp
  } else if (now - parsedLastConnect > alertRange && !machine.bandwidth) {
    status = 4; // not connected since a while
  } else if (now - parsedLastBkp > alertRange) {
    status = 3; // not bkp since a while
  } else if (now - parsedLastChanges > alertRange) {
    status = 2; // not sent since a while
  }
  BaseData.status = status;
  BaseData.lastBkp = parsedLastBkp;
  BaseData.lastChanges = parsedLastChanges;
  BaseData.lastConnected = parsedLastConnect;
  BaseData.lastConnectedAdjusted = machine.bandwidth
    ? parsedLastConnect - now
    : now - parsedLastConnect;
  return BaseData;
};
